import React, {useState} from 'react';
import useAuth from "../../../components/hooks/useAuth";
import {useNavigate} from "react-router";
import axios from "axios";
import {routes} from "../../../utils";
import {Alert} from "react-bootstrap";
import Loading from "../../../components/Loading";
import PasswordConfirmationButton from "../../../components/PasswordConfirmationButton";
import {backendEndpoints} from "../../../libs/backendEndpoints";


/**
 * Component rendering the summary of the user's two-factor authentication status.
 * Provides functionality to enable or disable two-factor authentication based on the user's current settings.
 *
 * @return {JSX.Element} Returns a JSX structure with options to either enable or disable two-factor authentication,
 * as well as loading and error handling states.
 */
export default function TwoFactorAuthenticationSummary() {
    const { user, reloadUser, isLoading: isLoadingUser } = useAuth();
    const navigate = useNavigate();
    const [error, setError] = useState('');

    const enable2fa = () => {
        setError('');
        return axios.post(backendEndpoints.twoFactorAuthentication, null, {
            withCredentials: true,
            withXSRFToken: true,
        })
            .then(({ data }) => {
                navigate(routes.twoFactorAuthentication)
            })
            .catch((e) => {
                setError(e.response.data?.message || e.response.message || 'Something went wrong...')
            })
    }
    const disable2fa = () => {
        setError('');
        return axios.delete(backendEndpoints.twoFactorAuthentication)
            .then(({ data }) => {
                reloadUser();
            })
            .catch((e) => {
                setError(e.response.data?.message || e.response.message || 'Something went wrong...')
            })
    }

    if (isLoadingUser) {
        return <Loading />
    }

    return !user?.has_2fa_enabled
        ? (
            <>
                <PasswordConfirmationButton
                    variant="danger"
                    onSuccess={enable2fa}
                    buttonText="Enable 2FA"
                />
                {error && <Alert variant="danger">{error}</Alert>}
            </>
        ) : (
            <>
                <p>
                    <strong className="text-success">Two factor authentication is enabled.</strong>
                </p>
                <PasswordConfirmationButton
                    variant="danger"
                    buttonText="Disable 2FA"
                    onSuccess={disable2fa}
                />
                {error && <Alert variant="danger">{error}</Alert>}
            </>
        );
}
